export const UPDATE_QUESTION_PAPER_COMPLEXITY = 'questionPaperInsights/COMPLEXITY';

export const updateQuestionPaperComplexity = (response) => {
  return {
    type: UPDATE_QUESTION_PAPER_COMPLEXITY,
    payload: response,
  };
};
